import React, { Component } from 'react';
import Fetch from './Fetch';
import './LoginForm.css';
import { Button, TextField, Dialog, DialogTitle, DialogContent, DialogActions, Grid } from '@material-ui/core';
import { FiLogIn } from "react-icons/fi";
import Alert from '@material-ui/lab/Alert';
import Constantes from './Constantes';
import { withStyles } from '@material-ui/core/styles';

const useStyles = {
  'root': {
    flexGrow: 1,
    marginTop: '-150px',
    marginBottom: '50px;',
  },
  'rootError': {
    flexGrow: 1,
    marginTop: '-150px',
    marginBottom: '30px;',
  },
  'image': {
    position: 'relative',
    height: '200px',
    width: '200px',
    backgroundImage: "url('" + Constantes.url + "image/logo.png')",
    backgroundSize: '200px 200px',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center',
    opacity: '0.2'
  },
  'couleurOr': {
    backgroundColor: 'rgba(255,206,28,0.8)',
    color: 'black',
    "&:hover": {
      backgroundColor: 'rgba(255,206,28,1)'
    }
  }
};

class LoginForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      login: '',
      password: '',
      enCoursDeConnexion: false,
      openDialog: false,
      message: false
    };
  }

  connexionServeur() {
    var identification = {
      login: this.state.login,
      password: this.state.password
    };

    const reussite = retour => {
      this.setState({ enCoursDeConnexion: false });
      if (retour) {
        localStorage.setItem("token", retour.token);
        this.props.submit();
      } else {
        this.setState({ message: "Login/Password incorrect" });
      }
    }
    Fetch.requete({ url: "/login", data: identification }, reussite)
  }


  handleChange = event => {

    this.setState({ [event.target.name]: event.target.value, message: false });
  }

  handleSubmit = event => {
    event.preventDefault();
    this.setState({ enCoursDeConnexion: true });
    this.connexionServeur();
  }

  handleClose = () => {
    this.setState({ openDialog: false });
  }

  saisirIdentifiant = () => {
    this.setState({ openDialog: true });
  }

  keyPress = e => {
    if (e.key === 'Enter') {
      this.handleSubmit(e);
    }
  }

  render() {

    const { classes } = this.props;
    const { enCoursDeConnexion, openDialog, message } = this.state;
    const { handleSubmit, handleClose, saisirIdentifiant, keyPress } = this;

    return (

      <div>
        {!enCoursDeConnexion &&
          <Button variant="contained" size="small" color="primary" startIcon={<FiLogIn />}
            onClick={saisirIdentifiant} >Se connecter</Button>
        }
        {
          enCoursDeConnexion &&
          <div>Connexion en cours </div>
        }

        <Dialog open={openDialog} onClose={handleClose} >
          <DialogTitle id="max-width-dialog-title">Connexion à l'application</DialogTitle>
          <DialogContent >


            <div className={classes.image}></div>

            < form onSubmit={this.handleSubmit} >
              <Grid
                className={message ? classes.rootError : classes.root}
                container
                direction="column"
                justify="center"
                alignItems="center"
                spacing={1}
              >
                <Grid item>
                  <TextField
                    size="small" label="Login"
                    variant="outlined" type="text" name="login"
                    value={this.state.login} onChange={this.handleChange}
                    onKeyPress={keyPress} />
                </Grid>
                <Grid item>
                  <TextField
                    size="small" label="Password"
                    variant="outlined" type="password" name="password"
                    value={this.state.password} onChange={this.handleChange}
                    onKeyPress={keyPress} />
                </Grid>
                {message && <Grid item><Alert severity="error">{message}</Alert></Grid>}
              </Grid>

            </form>
          </DialogContent>
          <DialogActions>
            <Button variant="contained"
              onClick={handleSubmit} className={classes.couleurOr}>
              Consommer
            </Button>
            <Button variant="contained" onClick={handleClose} color="primary">
              Annuler
            </Button>
          </DialogActions>
        </Dialog>

      </div >
    );
  }
}


const StyledLoginForm = withStyles(useStyles)(LoginForm);

export default StyledLoginForm;